export const useUTMParams = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const filteredParams = new URLSearchParams();

  for (const [key, value] of searchParams.entries()) {
    if (key.startsWith('utm')) {
      filteredParams.append(key, value);
    }
  }

  return filteredParams;
};
